import { createRealtimeEventBus } from '@src/shared/realtime';

/** Topic on the shared application socket, matching ALERT_SUMMARY_TOPIC in
 * apps/alerts/services/summary_events.py. */
export const ALERT_SUMMARY_TOPIC = 'alerts.summary';

export type AlertSummaryChangedEvent = {
  reason: string;
  alertId?: number;
};

const alertRealtimeEventBus =
  createRealtimeEventBus<AlertSummaryChangedEvent>();

export function publishAlertRealtimeEvent(event: AlertSummaryChangedEvent) {
  alertRealtimeEventBus.publish(event);
}

export function subscribeToAlertRealtimeEvents(
  listener: (event: AlertSummaryChangedEvent) => void,
) {
  return alertRealtimeEventBus.subscribe(listener);
}
